import React from "react";
import { Alert, AlertTitle } from "@mui/material";
import i18n from "i18";

/**
 * Shown instead of any purchase control when the plan is billed by the App Store.
 * @param {Object} props - Component props
 * @param {"plan"|"credits"} [props.variant] - What the user was about to buy
 * @param {Object} [props.sx] - Extra MUI styles
 * @returns {JSX.Element} Info alert pointing at the App Store
 */
export default function AppStoreBillingNotice({ variant = "plan", sx }) {
  return (
    <Alert severity="info" sx={{ mb: 2, ...sx }}>
      <AlertTitle>{i18n.t("billing.appStoreTitle")}</AlertTitle>
      {variant === "credits"
        ? i18n.t("billing.appStoreCredits")
        : i18n.t("billing.appStorePlan")}
    </Alert>
  );
}
